const calculateAverageSessionScore = (sessionHistory) => {
   const { sessions, scoreSum } = sessionHistory.reduce(
      (totals, session) => ({
         sessions: totals.sessions + 1,
         scoreSum: totals.scoreSum + session.score,
      }),
      { sessions: 0, scoreSum: 0 }
   );

   if (sessions === 0) {
      return 0;
   }

   return scoreSum / sessions;
};

export { calculateAverageSessionScore };
